import { axiosBaseQuery } from "@king-ict/eupisi-ui/utils";
import { createApi } from "@reduxjs/toolkit/query/react";

import { CommitteeResponse, RegionalCommittee } from "../models/Committee";

export const committeeApi = createApi({
  reducerPath: "committeeApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["InstitutionCountyCommittee", "RegionalCommittee"],
  endpoints: (build) => ({
    getInstitutionCountyCommittee: build.query<CommitteeResponse, number>({
      query: (requestId: number) => ({
        url: `request/get-institution-county-committees/${requestId}`,
      }),
    }),
    getRegionalCommitteeById: build.query<RegionalCommittee, number>({
      query: (id: number) => ({
        url: `regional-committee/get/${id}`,
      }),
    }),
    deleteCountyCommittee: build.mutation<void, number>({
      query: (countyCommitteeId: number) => ({
        url: `county-committees/${countyCommitteeId}`,
        method: "delete",
      }),
    }),
    deleteInstitutionCommittee: build.mutation<void, number>({
      query: (institutionCommitteeId: number) => ({
        url: `institution-committees/${institutionCommitteeId}`,
        method: "delete",
      }),
    }),
    deleteRegionalCommittee: build.mutation<void, number>({
      query: (regionalCommitteeId: number) => ({
        url: `regional-committee/${regionalCommitteeId}`,
        method: "delete",
      }),
    }),
    deleteMinistryCommittee: build.mutation<void, number>({
      query: (ministryCommitteeId: number) => ({
        url: `ministry-committees/${ministryCommitteeId}`,
        method: "delete",
      }),
    }),
  }),
});

export const {
  useGetInstitutionCountyCommitteeQuery,
  useGetRegionalCommitteeByIdQuery,
  useDeleteCountyCommitteeMutation,
  useDeleteInstitutionCommitteeMutation,
  useDeleteRegionalCommitteeMutation,
  useDeleteMinistryCommitteeMutation,
} = committeeApi;
